import { IRuntimeConfig } from "@finbackoffice/fe-core";
import { FC, createContext } from "react";

type IProps = {
    children: React.ReactNode;
    config: IRuntimeConfig;
};

export const RuntimeConfigContext = createContext<IRuntimeConfig>(null as any);

export const RuntimeConfigProvider: FC<IProps> = ({ children, config }) => {
    return <RuntimeConfigContext.Provider value={config}>{children}</RuntimeConfigContext.Provider>;
};
